import { MotionConfig } from 'motion/react'
import { useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@/components/layout/ThemeProvider'
import { LaunchTransitionOverlay } from '@/components/transitions/LaunchTransitionOverlay'
import { WelcomeTransitionOverlay } from '@/components/transitions/WelcomeTransitionOverlay'
import { SettingsDialog } from '@/components/ui/settings-dialog'
import { Toaster } from '@/components/ui/sonner'
import { SettingsProvider, useSettings } from '@/contexts/SettingsContext'
import { routePaths, routes } from '@/lib/router'
import { appcuesService } from '@/services/appcues'

// Create router with proper nested route handling
const router = createBrowserRouter([
  ...routes,
  {
    path: '*',
    element: <NotFoundPage />,
  },
])

// Component to handle global settings modal
function GlobalSettings() {
  const { isOpen, closeSettings } = useSettings()

  return <SettingsDialog open={isOpen} onOpenChange={closeSettings} />
}

function App() {
  useEffect(() => {
    appcuesService.init()
    return () => {
      appcuesService.destroy()
    }
  }, [])

  return (
    <MotionConfig reducedMotion="user">
      <ThemeProvider defaultTheme="dark">
        <SettingsProvider>
          <div className="min-h-screen text-foreground">
            <RouterProvider router={router} />
            <LaunchTransitionOverlay />
            <WelcomeTransitionOverlay />
            <Toaster />
            <GlobalSettings />
          </div>
        </SettingsProvider>
      </ThemeProvider>
    </MotionConfig>
  )
}

// Simple 404 page component
function NotFoundPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-muted-foreground">404</h1>
        <p className="text-xl text-muted-foreground">Page not found</p>
        <a
          href={routePaths.dashboard}
          className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          Go to Dashboard
        </a>
      </div>
    </div>
  )
}

export default App
